
import { defineComponent, PropType, readonly, computed, ref, Ref } from "vue";
export default defineComponent({
  props: {
    /**
     * @param {Array} buttonGroup 按钮组信息
     */
    buttonGroup: {
      type: Array as PropType<any[]>,
      default: (): any[] => [],
    },

    /**
     * @param {Array} tabs 选项卡列表
     */
    tabs: {
      type: Array as PropType<any[]>,
      default: (): any[] => [],
    },

    /**
     * @param {Boolean} loading 加载状态
     */
    loading: {
      type: Boolean,
      default: false,
    },

    /**
     * @param {Boolean} count 计数信息
     */
    count: {
      type: Object,
      default: (): any => {
        return {};
      },
    },

    /**
     *@param name值
     */
    modelValue: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleClick(tab: any) {
      this.$emit("update:modelValue", tab.props.name);
      this.$emit("handleClick");
    },
  },
});
